import Cookies from 'js-cookie'

const TokenKey = 'Authorization'

export function getToken(tokenKey) {
  if (!tokenKey) {
    tokenKey = TokenKey
  }
  return Cookies.get(tokenKey)
}

export function setToken(token, tokenKey) {
  if (!tokenKey) {
    tokenKey = TokenKey
  }
  return Cookies.set(tokenKey, token)
}

export function removeToken(tokenKey) {
  if (!tokenKey) {
    tokenKey = TokenKey
  }
  return Cookies.remove(tokenKey)
}
